import React from 'react';
import BaseController from 'app/backbone/helpers/BaseController';
import CreateItineraryContactView from 'app/backbone/views/event/artists/bookings/itinerary_contacts/Create.view'
import * as Routes from './routes'

export default class ReportsController extends BaseController {

    constructor(options = {}) {
        super(options);
        this.router.route(Routes.createItineraryContact(), null, this.reports.bind(this));
    }

    reports() {
        this.app.renderContentView(new CreateItineraryContactView());
    }

}
